import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=1aac46ad&scoped=true&"
import script from "./FooterHome.vue?vue&type=script&lang=js&"
export * from "./FooterHome.vue?vue&type=script&lang=js&"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=1aac46ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac46ad",
  null
  
)

export default component.exports